import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PdfViewerPage = _resolveComponent("PdfViewerPage")!

  return (_openBlock(), _createBlock(_component_PdfViewerPage, {
    title: "Danh sách cấp sửa chữa",
    count: _ctx.items.length,
    "count-label": "cấp",
    source: _ctx.pdfSource,
    "file-name": _ctx.pdfFileName,
    loading: _ctx.isGenerating,
    "fallback-route-name": "danh-sach-cap-sua-chua"
  }, null, 8, ["count", "source", "file-name", "loading"]))
}